import { useAccount, useConfig } from "wagmi";
import { useClient, useWriteContract } from "wagmi";
import { useCallback, useEffect, useState } from "react";
import { readContracts } from "@wagmi/core";
import AddressDividendAbi from "../assets/abis/AddressDividend.json";
import TeamNumAbi from "../assets/abis/TeamNum.json";
import { W3TeamNum, ad, MIN, MAX } from "../constants";
import { parseEther, formatUnits } from "viem";
const generateRandomAmount = () => {
  // const min = 0.00043;
  // const max = 0.0006;
  const randomAmount = (Math.random() * (MAX - MIN) + MIN).toFixed(6); // 6 decimal places for precision
  return randomAmount;
};
function useW3TeamNum() {
  const { address } = useAccount()
  const config = useConfig()
  const [value, setValue] = useState(null)
  const [refreshTime, setRefreshTime] = useState(Date.now())
  const [loading, setLoading] = useState(false)
  const client = useClient()
  const { writeContractAsync, waitForTransactionReceipt } = useWriteContract();

  useEffect(() => {
    const inc = setInterval(() => {
      setRefreshTime(Date.now())
    }, 6000)
    return () => clearInterval(inc)
  }, []);
  const fetch = useCallback(async () => {
    try {
      const teamnums = await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: TeamNumAbi,
            address: W3TeamNum,
            functionName: 'calculateTeamNum',
            args: [address, 1, 4]
          }
        ]
      });
      const myteamLevels = await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: TeamNumAbi,
            address: W3TeamNum,
            functionName: 'userTeamLevel',
            args: [address]
          }
        ]
      });
      // console.log('myteamLevels',Number(formatUnits(myteamLevels[0],0)) );
      const withdrawableDividendOf = await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: AddressDividendAbi,
            address: ad[myteamLevels[0] ? Number(formatUnits(myteamLevels[0],0))-1 : 0],
            functionName: 'dividendOf',
            args: [address]
          }
        ]
      });
      // console.log('withdrawableDividendOf',withdrawableDividendOf); 
      const upNeed = await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: TeamNumAbi,
            address: W3TeamNum,
            functionName: 'teamLevel',
            args: [myteamLevels[0] ? myteamLevels[0] : 0]
          }
        ]
      });
      // console.log(teamnums[0] >= upNeed[0]);
      setValue({
        teamnum: teamnums[0] ? formatUnits(teamnums[0], 0) : 0,
        isUpLevel:  teamnums[0] >= upNeed[0] ? true : false,
        myteamLevel: myteamLevels[0] ? formatUnits(myteamLevels[0], 0)  : 0,
        withdrawableDividendOf: withdrawableDividendOf[0] ? parseFloat(formatUnits(withdrawableDividendOf[0], 18)).toFixed(2) : 0,
      })

    } catch (e) {
      console.log(e)
    }
  }, [address, config]);

  const updateTeamNum = useCallback(async () => {
    try {
      setLoading(true)
      try {
        const randomAmount = generateRandomAmount();
        const hash = await writeContractAsync({
          abi: TeamNumAbi,
          address: W3TeamNum,
          functionName: 'upTeamlevel',
          // args: [address],
          value:parseEther(randomAmount),
        })
        await waitForTransactionReceipt(client,
          { hash, confirmations: 3, pollingInterval: 3000 })
      } catch (e) {
        console.log(e)
      } finally {
          setLoading(false)
      }
    } catch (e) {
      console.log(e)
    }
  }, [writeContractAsync,client, waitForTransactionReceipt]);
    const onClaimTeamReward = useCallback(async () => {
    try {
      setLoading(true)
      if (value.myteamLevel<=0){
        alert("Your team level is 0, unable to claim rewards");
        setLoading(false)
        return;
      }
      try {
        const randomAmount = generateRandomAmount();
        const hash = await writeContractAsync({
          abi: AddressDividendAbi,
          address: ad[value.myteamLevel-1],
          functionName: 'withdrawDividend',
          // args: [address],
          value:parseEther(randomAmount),
        })
        await waitForTransactionReceipt(client,
          { hash, confirmations: 3, pollingInterval: 3000 })
      } catch (e) {
        console.log(e)
      } finally {
          setLoading(false)
      }
    } catch (e) {
      console.log(e)
    }
  }, [client,waitForTransactionReceipt,value, writeContractAsync]);
  useEffect(() => {
    if (config && address) {
      fetch()
    } else {
      setValue(null)
    }
  }, [fetch, config, address, refreshTime]);

  return { value, updateTeamNum,onClaimTeamReward, loading };
}

export default useW3TeamNum;